import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { CreateBannedTailNumberRequestBody, PatchBannedTailNumberRequestBody } from '@/api/apis/resources';
import { bannedTailNumbersQueryKeys } from '@/queries/banned-tail-numbers/banned-tail-numbers.keys';

type RemoveBannedTailNumberMutationVars = {
  id: string;
};

export const useCreateBannedTailNumberMutation = () => {
  return useMutation({
    mutationFn: (variables: CreateBannedTailNumberRequestBody) => api.resource.createBannedTailNumber(variables),
    meta: {
      invalidates: [bannedTailNumbersQueryKeys.getList()],
    },
  });
};

export const useUpdateBannedTailNumbersMutation = () => {
  return useMutation({
    mutationFn: (variables: PatchBannedTailNumberRequestBody & { id: string }) =>
      api.resource.updateBannedTailNumber(variables),
    meta: {
      invalidates: [bannedTailNumbersQueryKeys.getList()],
    },
  });
};

export const useRemoveBannedTailNumberMutation = () => {
  return useMutation({
    mutationFn: (variables: RemoveBannedTailNumberMutationVars) => api.resource.removeBannedTailNumber(variables.id),
    meta: {
      invalidates: [bannedTailNumbersQueryKeys.getList()],
    },
  });
};
